"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var WeblabRulesResolverAbstract_1 = __importDefault(require("./WeblabRulesResolverAbstract"));
var WeblabRulesResolverImpl = /** @class */ (function (_super) {
    __extends(WeblabRulesResolverImpl, _super);
    function WeblabRulesResolverImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WeblabRulesResolverImpl.prototype.resolve = function (defaultValue, weblabContext, weblabRules) {
        var _a;
        if (!this.validateInput(weblabContext, weblabRules)) {
            return defaultValue;
        }
        var weblabTreatmentMap = this.getWeblabTreatments(this.getDistinctWeblabNames(weblabRules), weblabContext);
        return (_a = this.findMatchingValue(weblabRules, weblabTreatmentMap)) !== null && _a !== void 0 ? _a : defaultValue;
    };
    WeblabRulesResolverImpl.prototype.getWeblabTreatments = function (weblabNames, weblabContext) {
        var _this = this;
        var useContext = weblabContext !== undefined;
        return new Map(Array.from(weblabNames, function (name) { return [
            name,
            useContext
                ? _this.weblabWithContextTreatmentResolver
                    .getTreatment(name, weblabContext)
                : _this.weblabTreatmentResolver.getTreatment(name),
        ]; }));
    };
    return WeblabRulesResolverImpl;
}(WeblabRulesResolverAbstract_1.default));
exports.default = WeblabRulesResolverImpl;
